import PatientWhitelist from './PatientWhitelist'

export default interface Patient extends PatientWhitelist {
  password: string
}

export enum patientStatus {
  active = 'active',
  inactive = 'inactive',
  limited = 'limited',
}

export enum patientSignInStatus {
  pending = 'pending',
  waitingPassword = 'waitingPassword',
  active = 'active',
  locked = 'locked',
  changeForcePassword = 'changeForcePassword',
  multiFactorAuthentication = 'multiFactorAuthentication',
}

export enum patientStatusCalculate {
  normal = 'normal',
  urgent = 'urgent',
  emergency = 'emergency',
}

export enum patientTypeStatus {
  examination = 'examination',
  chat = 'chat',
  discussion = 'discussion',
}

export interface PatientStatusOne {
  patientId: string
  patientFullName: string
  reason: string
  statusCalculate: patientStatusCalculate
  typeStatus: patientTypeStatus
  dateManage: string
  dateManageNavbar: string
  reasonsNavbar: Array<string>
}
